// extracted by mini-css-extract-plugin
module.exports = {"animSlideTop":"NotificationManager_animSlideTop_3-0tk","animSlideBottom":"NotificationManager_animSlideBottom_2AOgZ"};